/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AddSiteGroup({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.25 1.401a.6.6 0 1 1 0 1.2h-6a.4.4 0 0 0-.4.4v7c0 .22.18.4.4.4h9a.4.4 0 0 0 .4-.4v-1.5a.6.6 0 1 1 1.2 0v1.5a1.6 1.6 0 0 1-1.6 1.6h-6.4V13c0 .22.18.4.4.4h9a.4.4 0 0 0 .4-.4v-5.75a.6.6 0 1 1 1.2 0v5.75a1.6 1.6 0 0 1-1.6 1.6h-9a1.6 1.6 0 0 1-1.6-1.6v-1.4h-1.4A1.6 1.6 0 0 1 .65 10v-7a1.6 1.6 0 0 1 1.6-1.6h6Zm4.697-.85a.6.6 0 0 1 .6.6V2.96h1.811a.6.6 0 0 1 .001 1.2h-1.811v1.736a.6.6 0 0 1-1.2 0V4.16l-1.736.001a.6.6 0 0 1 .001-1.2h1.735V1.15a.6.6 0 0 1 .6-.6ZM8.25 4.4a.6.6 0 1 1 0 1.2h-4a.6.6 0 1 1 0-1.2h4Z" /></svg>;
}
;